import React from "react";
import { Tooltip } from "@blueprintjs/core";

const Moderator = ({
  isCurrentUser,
  moderator,
  deleteModeratorFromConference,
  canRemoveModerator,
  role,
}) => {
  const moderatorInfo = moderator.moderator;

  return (
    <div className="moderator-controls">
      <Tooltip
        content="This moderator already has an interview scheduled that conflicts with this time. Proceed with caution."
        isDisabled={!moderator.hasConflict}
        popoverClassName="modal-moderator-tooltip"
      >
        <div
          className={`moderator ${moderator.isHost ? "host-moderator" : ""} ${
            isCurrentUser ? "current-moderator" : ""
          } ${role === 2 ? "pm-role" : ""} `}
        >
          {moderator.isHost ? (
            <img src="/stylesheets/Qual-Scheduler/host_icon.svg" alt="Host" />
          ) : (
            <i className="im-user2" />
          )}
          <span className="moderator-inline">
            <b>{`Moderator\u00A0${moderatorInfo.id}:`}</b>
            {`\u00A0${moderator.label}`}
          </span>
          {moderator.hasConflict === 1 ? <i className="im-warning" /> : ""}
        </div>
      </Tooltip>
      <Tooltip
        content="To remove this moderator from the list you must include at least one moderator without conflicts."
        isDisabled={canRemoveModerator}
      >
        {/* <i
          className={`im-ss-delete ${canRemoveModerator ? '' : 'disabled'}`}
          onClick={() => canRemoveModerator && deleteModeratorFromConference(moderatorInfo.id)}
        /> */}
      </Tooltip>
    </div>
  );
};

export default Moderator;
